<template>
  <div class="th-list-course">
    <h2 class="th-title"><b> Data Center Dashboard</b></h2>
    <a-card>
      <div class="mb-3 row">
        <div class="col-2 m-1">
          <a-input-search
            placeholder="Cari Nama atau ID Aset..."
            @input="handleSearch"
            v-model:value="search"
          />
        </div>
        <!-- <div class="col-2 m-1">
          <a-select v-model:value="selectedFilterLokasi" style="width: 220px">
            <a-select-option v-for="(item, i) in filterLokasi" :key="i" :value="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </div>
        <div class="col-2 m-1">
          <a-select v-model:value="selectedFilterRuang" style="width: 220px;margin-left: 40px;">
            <a-select-option v-for="(item, i) in filterRuang" :key="i" :value="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </div> -->
        <div
          class="col m-1 w-100 d-flex justify-content-end align-items-center"
          v-if="role !== 'dcOwner'"
          style="gap: 10px;"
        >
          <a-button @click="handleExportExcel" :loading="loadingExport">
            <CloudDownloadOutlined />Export to Excel
          </a-button>
          <router-link :to="`${currentRoute.currentRoutes}`">
            <a-button> <PlusOutlined />New {{ currentRoute.strRouteCapital }} </a-button>
          </router-link>
        </div>
      </div>
      <div class="w-100" style="overflow-x:auto ;">
        <a-table
          :pagination="globalPagination"
          :columns="columns"
          :data-source="filteredData"
          class="table"
          bordered
          table-layout="auto"
          :loading="loadingTable"
          @change="handleTableChange"
          :row-key="record => record.id"
        >
          <template #Asset="{ text, record }">
            <router-link
              class="th-link"
              :to="{
                name: 'Detail Request',
                params: { id: record.id },
              }"
            >
              {{ text ? text.name : record.id }}
            </router-link>
            <br />
            <!-- <small>
              {{ text.AssetSubCategory.name }}
            </small> -->
          </template>
          <template #AssetCat="{ record }">
            <span>{{
              record.Asset
                ? record.Asset.AssetSubCategory.AssetCategory.name
                : record.AssetSubCategory
                ? record.AssetSubCategory.AssetCategory.name
                : '-'
            }}</span>
            <br />
            <small>
              <span>{{
                record.Asset
                  ? record.Asset.AssetSubCategory.name
                  : record.AssetSubCategory
                  ? record.AssetSubCategory.name
                  : '-'
              }}</span>
            </small>
          </template>
          <template #createdAt="{ record }">
            <span v-if="record && record.tanggal_request">
              {{ formatDate(record.tanggal_request) }}
            </span>
            <span v-else>-</span>
          </template>
          <template #updatedAt="{ record }">
            <span v-if="record && record.tanggal_selesai">
              {{ formatDate(record.tanggal_selesai) }}
            </span>
            <span v-else>-</span>
          </template>
          <template #status="{ text }">
            <a-tag v-if="text === 'Pending'" color="orange">
              Pending
            </a-tag>
            <a-tag v-else-if="text === 'In Progress'" color="blue">
              In Progress
            </a-tag>
            <a-tag v-else-if="text === 'Completed'" color="green">
              Completed
            </a-tag>
            <a-tag v-else color="default">
              {{ text }}
            </a-tag>
          </template>
          <template #action="{ record }">
            <a-button type="primary" danger size="small" @click="showDeleteModal(record.id)">
              <DeleteOutlined />
            </a-button>
          </template>
          <!-- <template #AssetSubCategory="{text}">
            <div>
              {{ text.name }}
              <br />
              <span class="text-muted">
                {{ text.AssetCategory.name }}
              </span>
            </div>
          </template>
          <template #Manufacturer="{text}">
            {{ text.name }}
            <br />
            <span class="text-muted"># {{ text.tag }}</span>
          </template>
          <template #Customer="{text}">
            {{ text.name }}
            <br />
            <span class="text-muted">
              {{ text.officeNumber }}
              <br />
              {{ text.email }}
            </span>
          </template>
          <template #Location="{text,record}">
            {{ text.name }}
            <br />
            <span class="text-muted">
              {{ record.Room.name }}
            </span>
          </template> -->
        </a-table>
      </div>
    </a-card>

    <!-- Delete Confirmation Modal -->
    <a-modal
      v-model:visible="deleteModalVisible"
      title="Konfirmasi Hapus"
      ok-text="Hapus"
      cancel-text="Batal"
      ok-type="danger"
      :confirm-loading="deleteLoading"
      @ok="handleDelete"
    >
      <p>Apakah Anda yakin ingin menghapus data change request ini?</p>
    </a-modal>
  </div>
</template>

<script>
/* eslint-disable */
import {
  onMounted,
  ref,
  reactive,
  createVNode,
  toRef,
  toRefs,
  computed,
  onBeforeMount,
  watch,
} from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { baseURL } from '@/services/axios'
import {
  CheckOutlined,
  ToolOutlined,
  PhoneOutlined,
  SearchOutlined,
  PlusOutlined,
  CloudUploadOutlined,
  CloudDownloadOutlined,
  ExclamationCircleOutlined,
  CloseSquareOutlined,
  InfoCircleOutlined,
  HomeOutlined,
  DeleteOutlined,
} from '@ant-design/icons-vue'
import rupiahPrice from '@/helpers/rupiahPrice'

import fuzzysort from 'fuzzysort'
import { Modal, notification, message } from 'ant-design-vue'
import { useForm } from '@ant-design-vue/use'
import axios from 'axios'
import moment from 'moment'
import lodash from 'lodash'
import assetsFile from '@/data/modc_dump.json'
import { randomUUID } from '@/helpers/randomUUID'
import { getAssets } from '../../services/axios/modc/assets'
import { getListChangeRequest, deleteChangeRequest } from '../../services/axios/modc/helpdesk'
import * as XLSX from 'xlsx'

const columns = [
  {
    title: 'NAMA ASSET',
    dataIndex: 'Asset',
    className: '',
    key: 'Asset',
    slots: { customRender: 'Asset' },
    width: 150,
    // sorter: true,
  },
  {
    title: 'KATEGORI ASSET',
    dataIndex: 'Asset',
    className: '',
    key: 'AssetCat',
    slots: { customRender: 'AssetCat' },
    width: 200,
    // sorter: true,
  },
  {
    title: 'TIPE REQUEST',
    dataIndex: 'type',
    className: '',
    key: 'type',
    slots: { customRender: 'type' },
    width: 150,
    // sorter: true,
  },
  {
    title: 'TANGGAL REQUEST',
    dataIndex: 'createdAt',
    className: '',
    key: 'createdAt',
    slots: { customRender: 'createdAt' },
    width: 200,
    // sorter: true,
  },
  {
    title: 'TANGGAL SELESAI',
    dataIndex: 'updatedAt',
    className: '',
    key: 'updatedAt',
    slots: { customRender: 'updatedAt' },
    width: 200,
    // sorter: true,
  },

  {
    title: 'STATUS',
    dataIndex: 'status',
    className: '',
    key: 'status',
    slots: { customRender: 'status' },
    // width: 100,
    // sorter: true,
  },
  {
    title: 'NOTES',
    dataIndex: 'notes',
    className: '',
    key: 'notes',
    slots: { customRender: 'notes' },
    // width: 100,
    // sorter: true,
  },
  {
    title: 'ACTION',
    dataIndex: 'action',
    className: '',
    key: 'action',
    slots: { customRender: 'action' },
    width: 100,
    fixed: 'right',
  },
]

export default {
  components: {
    CloudUploadOutlined,
    CloudDownloadOutlined,
    InfoCircleOutlined,
    CheckOutlined,
    ToolOutlined,
    PhoneOutlined,
    HomeOutlined,
    PlusOutlined,
    DeleteOutlined,
  },
  setup() {
    /* eslint-disable */
    let store = useStore()
    const route = useRoute()
    let filteredData = ref([])
    let isSearching = ref(false)
    let loadingTable = ref(false)
    let globalPagination = ref({ current: 1, pageSize: 10 })
    let totalPages = ref([])

    let search = ref('')
    const currentRoute = computed(() => {
      const currentRoute = route.path.split('/').at(1)
      let strRouteCapital = currentRoute.split('')[0].toUpperCase() + currentRoute.slice(1)

      // let typeAssets = ''
      // switch (route.path.split('/').at(1)) {
      //   case 'facilities':
      //     typeAssets = 'Facility '
      //     break
      //   case 'passive':
      //     typeAssets = 'Passive '
      //     break
      //   case 'active':
      //     typeAssets = 'Active '
      //     break

      //   default:
      //     break
      // }
      // console.log(route.path.split('/').at(1) + '/create')
      return {
        strRouteCapital,
        currentRoutes: route.path.split('/').at(1) + '/create',
      }
    })

    //

    let filterLokasi = [
      'Filter Lokasi',
      'DC Salemba',
      'DC Depok',
      'Headquarter',
      'DC Graha Mustika',
      'Bakrie Center',
    ]
    let selectedFilterLokasi = ref('Filter Lokasi')
    let filterRuang = ref(['Filter Ruang', 'Network Operation', 'Main Genset', 'Ruang Testing'])
    let selectedFilterRuang = ref('Filter Ruang')

    const onSearch = async searchText => {
      if (searchText !== '') {
        isSearching.value = true
        loadingTable.value = true
        const res = await searchPotensi(searchText)
        console.log(res, 'res search')
        // const results = fuzzysort.go(searchText, potensiData.value, { key: 'name' })
        // const sortData = results.map(result => {
        //     return result.obj
        // })
        filteredData.value = res.result
        loadingTable.value = false
      } else {
        isSearching.value = false
        loadingTable.value = false
        fetchCourse(1)
      }
    }
    onBeforeMount(() => {
      fetchCourse()
      const storedUserData = localStorage.getItem('userData')
      const userData = JSON.parse(storedUserData)
      role.value = userData.user.role
    })
    const fetchCourse = async params => {
      loadingTable.value = true

      // console.log(route.path.split('/').at(-1), '<<<ROUTE', assetSubCategory, '<<<ASSET')
      const userLogin = JSON.parse(localStorage.getItem('userData'))
      const payload = {
        helpDeskId: userLogin.user.id,
        search: search.value,
      }
      const data = await getListChangeRequest(payload)
      // console.log(data, '<<<<<DATA')
      filteredData.value = data.changeRequestList

      loadingTable.value = false
      isSearching.value = false
      // globalPagination.value = { ...globalPagination.value, total: 0 }
      globalPagination.value = { ...globalPagination.value, total: data.changeRequestList.length }
    }

    const lodashSearch = lodash.debounce(() => {
      // console.log('masuk')
      fetchCourse()
    }, 1500)
    const handleSearch = () => {
      // console.log('inisearch')
      loadingTable.value = true
      globalPagination.value.current = 1
      const userLogin = JSON.parse(localStorage.getItem('userData'))
      lodashSearch()
      setTimeout(() => {
        loadingTable.value = false
        // console.log('masuk baru')
      }, 2500)
      const payload = {
        helpDeskId: userLogin.user.id,
        search: search.value,
      }
      // fetchCourse(payload)
    }
    const handleTableChange = (pag, filters, sorter) => {
      globalPagination.value.current = pag.current
      // if (sorter) {
      //   if (sorter.columnKey == 'key') sortBy.value = '_id'
      //   else sortBy.value = sorter.columnKey
      //   order.value = sorter.order
      // }
      fetchCourse()
    }
    const formatDate = date => {
      return moment(date).format('DD MMM YYYY HH:mm:ss')
    }

    const loadingExport = ref(false)

    const handleExportExcel = () => {
      loadingExport.value = true
      try {
        // Prepare data for export
        const exportData = filteredData.value.map(record => {
          return {
            'NAMA ASSET': record.Asset ? record.Asset.name : record.id,
            'KATEGORI ASSET': record.Asset
              ? record.Asset.AssetSubCategory.AssetCategory.name
              : record.AssetSubCategory
              ? record.AssetSubCategory.AssetCategory.name
              : '-',
            'SUB KATEGORI': record.Asset
              ? record.Asset.AssetSubCategory.name
              : record.AssetSubCategory
              ? record.AssetSubCategory.name
              : '-',
            'TIPE REQUEST': record.type || '-',
            'TANGGAL REQUEST': record.tanggal_request ? formatDate(record.tanggal_request) : '-',
            'TANGGAL SELESAI': record.tanggal_selesai ? formatDate(record.tanggal_selesai) : '-',
            STATUS: record.status || '-',
            NOTES: record.notes || '-',
          }
        })

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(exportData)

        // Set column widths
        ws['!cols'] = [
          { wch: 25 }, // NAMA ASSET
          { wch: 20 }, // KATEGORI ASSET
          { wch: 20 }, // SUB KATEGORI
          { wch: 15 }, // TIPE REQUEST
          { wch: 25 }, // TANGGAL REQUEST
          { wch: 25 }, // TANGGAL SELESAI
          { wch: 15 }, // STATUS
          { wch: 30 }, // NOTES
        ]

        // Create workbook
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Change Requests')

        // Generate filename with current date
        const filename = `Change_Requests_${moment().format('YYYY-MM-DD_HHmmss')}.xlsx`

        // Save file
        XLSX.writeFile(wb, filename)

        notification.success({
          message: 'Export Berhasil',
          description: `Data berhasil di-export ke ${filename}`,
        })
      } catch (error) {
        console.error('Error exporting:', error)
        notification.error({
          message: 'Export Gagal',
          description: 'Terjadi kesalahan saat export data',
        })
      } finally {
        loadingExport.value = false
      }
    }

    watch(route, (to, from) => {
      fetchCourse()
    })
    const role = ref('')
    const deleteModalVisible = ref(false)
    const deleteLoading = ref(false)
    const selectedDeleteId = ref(null)

    const showDeleteModal = id => {
      selectedDeleteId.value = id
      deleteModalVisible.value = true
    }

    const handleDelete = async () => {
      deleteLoading.value = true
      try {
        const res = await deleteChangeRequest(selectedDeleteId.value)
        console.log(res, '<<<<<RES DELETE')
        if (res.message === 'Change Request deleted successfully') {
          notification.success({
            message: 'Berhasil Hapus',
            description: 'Data Change Request berhasil dihapus',
          })
          // Refetch data after delete
          await fetchCourse()
          deleteModalVisible.value = false
        } else {
          notification.error({
            message: 'Gagal Hapus',
            description: 'Data Change Request gagal dihapus',
          })
        }
      } catch (error) {
        console.error('Error deleting:', error)
        notification.error({
          message: 'Error',
          description: 'Terjadi kesalahan saat menghapus data',
        })
      } finally {
        deleteLoading.value = false
      }
    }

    return {
      role,
      handleSearch,
      handleTableChange,
      currentRoute,
      search,
      filterLokasi,
      selectedFilterLokasi,
      filterRuang,
      selectedFilterRuang,
      globalPagination,
      columns,
      filteredData,
      loadingTable,
      formatDate,
      loadingExport,
      handleExportExcel,
      deleteModalVisible,
      deleteLoading,
      showDeleteModal,
      handleDelete,
    }
  },
}
</script>
<style lang="scss">
@import '../styleViews.scss';

.text-customer {
  font-size: 0.75rem;
}

.th-list-course {
  .th-link {
    color: var(--vb-color-primary) !important;

    &:hover {
      color: var(--kit-color-primary) !important;
    }
  }
}
</style>
